import { render, staticRenderFns } from "./GyPPatrimoniales.vue?vue&type=template&id=15113d52&"
import script from "./GyPPatrimoniales.vue?vue&type=script&lang=js&"
export * from "./GyPPatrimoniales.vue?vue&type=script&lang=js&"
import style0 from "./GyPPatrimoniales.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
installComponents(component, {VAlert,VCard,VCardText,VCardTitle})
